import { MemberAvatar } from '@tribeplatform/react-components/common/components/member'
import { T } from '@tribeplatform/react-components/i18n'
import { useAuthMember, useUnblockMember } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { List } from '@tribeplatform/react-ui-kit/Layout'
import { Media } from '@tribeplatform/react-ui-kit/Media'

import { BlockedMemberListLoading } from './BlockedMemberListLoading.js'
import { NoBlockedMembers } from './NoBlockedMembers.js'

export const BlockedMemberList = () => {
  const {
    data: authMember,
    isLoading,
    isFetched,
  } = useAuthMember({
    fields: {
      blockedMembers: 'basic',
    },
  })
  const members = authMember?.blockedMembers

  const { mutate: unblockMember } = useUnblockMember()

  return (
    <div className="flex flex-col space-y-5">
      {isFetched && !members?.length && !isLoading ? (
        <NoBlockedMembers />
      ) : (
        <div>
          <List>
            {members?.map(member => {
              if (!member?.id) {
                return null
              }
              return (
                <List.Item key={member.id}>
                  <Media
                    align="center"
                    icon={<MemberAvatar size="2.5x" member={member} />}
                    trailingVisual={
                      <Button
                        variant="secondaryNeutral"
                        onClick={e => {
                          e.preventDefault()
                          unblockMember({
                            memberId: member?.id,
                          })
                        }}
                      >
                        <T defaultMessage="Unblock" id="Generics.Unblock" />
                      </Button>
                    }
                  >
                    <div className="truncate text-content" translate="no">
                      {member?.name}
                    </div>
                    {member?.tagline && (
                      <div className="text-md text-content-subdued truncate">
                        {member?.tagline}
                      </div>
                    )}
                  </Media>
                </List.Item>
              )
            })}
          </List>

          {!isFetched || isLoading ? <BlockedMemberListLoading /> : null}
        </div>
      )}
    </div>
  )
}
